<template>
    <li class="dropdown messages-menu theme-switcher-menu">
        <a href="#" 
           data-toggle="dropdown" 
           class="dropdown-warning" 
           aria-expanded="false"
           title="Switch Theme">
            <i :class="currentThemeIcon"></i>
        </a>
        <ul class="dropdown-menu" style="min-width: 200px !important;">
            <li class="header">Select Theme</li>
            <li>
                <ul class="menu">
                    <li v-for="theme in availableThemes" 
                        :key="theme.value"
                        :class="{ 'active': currentTheme === theme.value }" 
                        style="width: auto;">
                        <a href="#" 
                           @click.prevent="switchTheme(theme.value)"
                           :class="{ 'active': currentTheme === theme.value }">
                            <i :class="theme.icon" style="margin-right: 8px;"></i>
                            <span class="title">{{ theme.label }}</span>
                            <i v-if="currentTheme === theme.value" 
                               class="fa fa-check pull-right" 
                               style="margin-top: 3px; color: #00a157;"></i>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </li>
</template>

<script>
export default {
    name: 'TopbarThemeSwitcher',
    props: {
        currentTheme: {
            type: String,
            required: true
        },
        updateRoute: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            availableThemes: [
                {
                    value: 'skin-green-light',
                    label: 'Light Theme',
                    icon: 'fa fa-sun-o'
                },
                {
                    value: 'skin-dark',
                    label: 'Dark Theme (Teal)',
                    icon: 'fa fa-moon-o'
                },
                {
                    value: 'skin-dark-brand',
                    label: 'Dark Brand (Azure)',
                    icon: 'fa fa-moon-o'
                }
            ],
            isLoading: false
        }
    },
    computed: {
        currentThemeIcon() {
            const theme = this.availableThemes.find(t => t.value === this.currentTheme);
            return theme ? theme.icon : 'fa fa-paint-brush';
        }
    },
    methods: {
        switchTheme(themeValue) {
            if (this.currentTheme === themeValue || this.isLoading) {
                return;
            }

            this.isLoading = true;

            const formData = new FormData();
            formData.append('settings_key', 'theme');
            formData.append('settings_data[theme]', JSON.stringify(themeValue));

            axios.post(this.updateRoute, formData)
                .then(response => {
                    if (response.data.success) {
                        const body = document.body;

                        this.availableThemes.forEach(theme => {
                            body.classList.remove(theme.value);
                        });

                        body.classList.add(themeValue);

                        this.$emit('update:currentTheme', themeValue);

                        this.showSuccessToast();

                        setTimeout(() => {
                            window.location.reload();
                        }, 300);
                    }
                })
                .catch(error => {
                    console.error('Error switching theme:', error);
                    this.showErrorToast();
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        showSuccessToast() {
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    icon: 'success',
                    title: 'Theme changed successfully'
                });
            }
        },
        showErrorToast() {
            if (typeof Swal !== 'undefined') {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    icon: 'error',
                    title: _t('ui.error_changing_theme')
                });
            }
        }
    }
}
</script>

<style scoped>
.theme-switcher-menu .menu li a {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    transition: background-color 0.3s ease;
}

.theme-switcher-menu .menu li.active a {
    font-weight: 600;
}

.theme-switcher-menu .menu li a:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.skin-dark .theme-switcher-menu .menu li a,
.skin-dark-brand .theme-switcher-menu .menu li a {
    color: #ffffff !important;
}

.skin-dark .theme-switcher-menu .menu li a:hover,
.skin-dark-brand .theme-switcher-menu .menu li a:hover {
    background-color: #3d3d3d !important;
    color: #ffffff !important;
}

.skin-dark .theme-switcher-menu .dropdown-menu,
.skin-dark-brand .theme-switcher-menu .dropdown-menu {
    background-color: #2d2d2d;
    border: 1px solid #444444;
}

.skin-dark .theme-switcher-menu .dropdown-menu .header,
.skin-dark-brand .theme-switcher-menu .dropdown-menu .header {
    background-color: #333333;
    color: #ffffff;
}

.skin-dark .theme-switcher-menu .menu li.active a i.fa-check {
    color: #14b8a6 !important;
}

.skin-dark-brand .theme-switcher-menu .menu li.active a i.fa-check {
    color: #3FA5D6 !important;
}
</style>
